import * as React from 'react';

import {useSelector} from '@xstate/react';
import useLabelTranslation from 'src/hooks/useLabelTranslation.ts';

import {selectError} from '../../selectors/commonSelector';
import {ErrorState} from '../../lib/error-state/error-state';
import {useBookingMachine} from '../../hooks/useBookingMachine';


export const BookingAvailabilityRangeError = () => {
  const {t} = useLabelTranslation();
  const {bookingActor} = useBookingMachine();
  const {errorMessage, allowRetry} = useSelector(bookingActor, (state) =>
    selectError(state, t),
  );

  const handleRetry = () => {
    bookingActor.send({type: 'retry'});
  };

  return (
    <ErrorState
      imageVariant="calendar"
      title={errorMessage}
      onRetry={handleRetry}
      allowRetry={allowRetry}
      description={t(
        'An_error_occurred_while_loading_the_availability_Please_try_again',
        'An error occurred while loading the availability. Please try again',
      )}
    />
  );
};
